// extracted by mini-css-extract-plugin
export default {"loadingState":"SearchState-module__loadingState--hYa6t","emptyState":"SearchState-module__emptyState--JOj2W","spinner":"SearchState-module__spinner--6j+7z"};